import { action, makeObservable, observable } from 'mobx';
import { RootStore } from './root';
/* eslint-disable-next-line import/no-extraneous-dependencies -- resolved via tsconfig paths to sibling package source */
import {
  WebAuthnEnrollmentStore,
  CreatePasskeyErrorCode,
} from '@wix/webauthn-management';

export type PasskeyEnrollmentStatus =
  | 'idle'
  | 'enrolling'
  | 'success'
  | 'error';

export class PasskeyEnrollStore {
  errorCode: CreatePasskeyErrorCode | null = null;
  enrollmentStatus: PasskeyEnrollmentStatus = 'idle';
  private readonly webAuthnEnrollmentStore: WebAuthnEnrollmentStore;

  constructor(private readonly rootStore: RootStore) {
    this.webAuthnEnrollmentStore = new WebAuthnEnrollmentStore();
    makeObservable(this, {
      errorCode: observable,
      enrollmentStatus: observable,
      enrollPasskey: action.bound,
      reset: action.bound,
    });
  }

  async enrollPasskey(): Promise<
    | { success: true; isBackedUp: boolean }
    | {
        success: false;
        errorCode: CreatePasskeyErrorCode;
        errorMessage: string;
      }
  > {
    this.errorCode = null;
    this.enrollmentStatus = 'enrolling';
    // Abort any pending passkey login get() (e.g. conditional UI) before create().
    this.rootStore.webauthnStore.abortWebAuthnAuthentication();

    const result = await this.webAuthnEnrollmentStore.enrollWebAuthn();

    if (result.success) {
      this.enrollmentStatus = 'success';
      return result;
    }

    this.enrollmentStatus = 'error';
    this.errorCode = result.errorCode;
    return result;
  }

  reset(): void {
    this.enrollmentStatus = 'idle';
    this.errorCode = null;
  }
}
